module.exports = __webpack_public_path__ + "static/media/valikko_liikenne.f29ceb58.jpg";